var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFaceOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5623 16.3027C15.1767 16.6113 14.6152 16.5511 14.3034 16.1697C14.2898 16.1538 14.1069 15.9468 13.7731 15.7382C13.3902 15.4988 12.8032 15.25 12.0001 15.25C11.197 15.25 10.6101 15.4988 10.2271 15.7382C10.036 15.8576 9.84557 15.9982 9.69684 16.1697C9.38507 16.5511 8.82351 16.6112 8.43789 16.3027C8.04975 15.9922 7.98682 15.4259 8.29733 15.0377C8.56974 14.7094 8.91275 14.437 9.27312 14.2118C9.89016 13.8261 10.8032 13.45 12.0001 13.45C13.197 13.45 14.1101 13.8261 14.7271 14.2118C15.0861 14.4362 15.4331 14.7086 15.7029 15.0377C16.0134 15.4259 15.9505 15.9922 15.5623 16.3027Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 10.2501C10.2501 10.9404 9.69045 11.5001 9.00009 11.5001C8.30974 11.5001 7.75009 10.9404 7.75009 10.2501C7.75009 9.55974 8.30974 9.00009 9.00009 9.00009C9.69045 9.00009 10.2501 9.55974 10.2501 10.2501Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 11.5001C15.6904 11.5001 16.2501 10.9404 16.2501 10.2501C16.2501 9.55974 15.6904 9.00009 15.0001 9.00009C14.3097 9.00009 13.7501 9.55974 13.7501 10.2501C13.7501 10.9404 14.3097 11.5001 15.0001 11.5001Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.1001C6.53248 2.1001 2.1001 6.53248 2.1001 12.0001C2.1001 17.4677 6.53248 21.9001 12.0001 21.9001C17.4677 21.9001 21.9001 17.4677 21.9001 12.0001C21.9001 6.53248 17.4677 2.1001 12.0001 2.1001ZM3.9001 12.0001C3.9001 7.52659 7.52659 3.9001 12.0001 3.9001C16.4736 3.9001 20.1001 7.52659 20.1001 12.0001C20.1001 16.4736 16.4736 20.1001 12.0001 20.1001C7.52659 20.1001 3.9001 16.4736 3.9001 12.0001Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceOutline);
export default __webpack_public_path__ + "static/media/sad_face_outline.20b22f8cdd6ca0a251e63fa416701985.svg";
export { ForwardRef as ReactComponent };